// extracted by mini-css-extract-plugin
module.exports = {"cover":"dish-image_cover__fcvhr"};